import React from 'react'

class BorrowerButton extends React.Component {
  render() {
    const { onClick, width = 'w-50', label1 = 'One', label2 = 'Two', value1='1', value2='2' } = this.props
    return (
      <div className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-block' data-toggle="buttons">
        <label id='1' className={`btn ${width} onboarding-form active`} onClick={() => onClick(value1)}>
          <input id='1' name='borrowers' type='radio' value='1' onClick={() => onClick(value1)} />
          {label1}
        </label>
        <label id='2' className={`btn ${width} onboarding-form`} onClick={() => onClick(value2)}>
          <input id='2' name='borrowers' type='radio' value='2' onClick={() => onClick(value2)} />
          {label2}
        </label>
      </div>
    )
  }
}

export default BorrowerButton;
